module.exports = __webpack_public_path__ + "img/call-me-emperor.233e7d0.png";